<template>
  <div>
    <b-modal class="text-center d-flex" id="video-ended" hide-footer>
      <div class="text-center">
        <b-button id="endvdownload" type="button" class="mt-4 mr-3">
          <span>
            <font-awesome-icon icon="cloud-download-alt"></font-awesome-icon>
            Download
          </span>
        </b-button>
        <b-button
          id="endvshare"
          type="button"
          class="mt-4"
          @click.prevent="showShare()"
        >
          <span>
            <font-awesome-icon icon="share-alt"></font-awesome-icon>
            Share
          </span>
        </b-button>
      </div>
      <div class="text-center">
        <b-button
          id="return"
          type="button"
          class="mt-4 btn-light"
          @click.prevent="hideModal()"
        >
          <span>
            <font-awesome-icon icon="file-video"></font-awesome-icon>
            Return to My Videos //
          </span>
        </b-button>
      </div>
      <div class="text-center">
        <b-button id="startover" type="button" class="mt-2 btn-light">
          <span>
            <font-awesome-icon icon="undo-alt"></font-awesome-icon>
            Start Process Over
          </span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "VideoEnded",
  methods: {
    hideModal() {
      this.$bvModal.hide("video-ended");
      this.$bvModal.hide("new-video");
    },
  },
};
</script>
